<template>
    <div aria-live="assertive" class="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start" style="z-index: 9999999;">
        <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
            <transition
                enter-active-class="transform ease-out duration-300 transition"
                enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                leave-active-class="transition ease-in duration-100"
                leave-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <div v-if="notificationState.show" class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
                    <div class="p-4">
                        <div class="flex items-start">
                            <!-- bell. -->
                            <div class="flex-shrink-0 mr-3" v-if="notificationState.type === 'bell'">
                                <span class="h-6 w-6 text-gray-400 top-1 fas fa-bell text-lg"></span>
                            </div>
                            <!-- info. -->
                            <div class="flex-shrink-0 mr-3" v-if="notificationState.type === 'info'">
                                <span class="h-6 w-6 text-gray-400 fas fa-info-circle text-md"></span>
                            </div>
                            <!-- Success. -->
                            <div class="flex-shrink-0 mr-3" v-if="notificationState.type === 'success'">
                                <svg class="h-6 w-6 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <!-- Danger. -->
                            <div class="flex-shrink-0 mr-3" v-if="notificationState.type === 'danger'">
                                <svg class="h-6 w-6 text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <!-- Warning. -->
                            <div class="flex-shrink-0 mr-3" v-if="notificationState.type === 'warning'">
                                <svg class="h-6 w-6 text-yellow-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                </svg>
                            </div>
                            <div class="w-0 flex-1 pt-0.5">
                                <p class="text-sm font-medium text-gray-900" v-if="notificationState.useRawTitle" v-html="notificationState.title"></p>
                                <p class="text-sm font-medium text-gray-900" v-else v-text="notificationState.title"></p>
                                <p v-if="notificationState.text && notificationState.useRawText" class="mt-1 text-sm text-gray-500" v-html="notificationState.text"></p>
                                <p v-else-if="notificationState.text" class="mt-1 text-sm text-gray-500" v-text="notificationState.text"></p>
                            </div>
                            <div class="ml-4 flex-shrink-0 flex">
                                <button @click.prevent="hide()" class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                                    <span class="sr-only">Close</span>
                                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    props: [],
    computed: {
        notificationState () {
            return Notifications.state
        },
    },
    methods: {
        hide () {
            Notifications.hide()
        },
    },
    mounted () {
        eventBus.$on('new-notification', () => {
            // Notifications.showLatestNotification()
        })
    }
}
</script>
